import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Toggle from './ui/toggle';

const initialState = {
  type: 'BrazeTrigger',
  brazeEvent: null,
  eventProperty: null,
};

const BrazeTrigger = ({ components, handlerSetComponents, id }) => {
  const [state, setState] = useState(initialState);
  const [isEventTypeArray, setIsEventTypeArray] = useState();

  const componentIndex = components.findIndex(obj => obj.id === id);
  const { component } = components[componentIndex];

  useEffect(() => {
    if (component) {
      setState(component);
      setIsEventTypeArray(!!component.eventProperty);
    }
  }, []);

  useEffect(() => {
    const updatedComponent = {
      id,
      component: state,
    };

    handlerSetComponents(updatedComponent, componentIndex);
  }, [state]);

  const handleInput = (e) => {
    const { name, value } = e.target;
    setState({
      ...state,
      [name]: value,
    });
  };

  const handleEventType = (e) => {
    const { checked } = e.target;

    if (!checked) {
      setState({
        ...state,
        eventProperty: null,
      });
    }

    setIsEventTypeArray(checked);
  };

  return (
    <div className="text-black">
      <div className="flex-1 mr-4 -mx-3">
        <div className="w-full px-3 mb-4">
          <p className="block tracking-wide text-gray-700 text-xs">
            Add the name of the event you want to log on Braze.
            <br />
            <br />
            NOTE: The most common naming structure is
            {' '}
            <em>group_noun_action</em>
            {'. '}
            Events should all be lower case to avoid casing instrumentation errors and identifying properties.
          </p>
        </div>
        <div className="flex">
          <div className="w-1/2 sm:w-full px-3 md:mb-0">
            <label htmlFor="brazeEvent" className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-3">
              Braze event name
              <input
                className="appearance-none block w-full bg-gray-200 text-gray-700 border border-red-500 rounded py-3 px-4 mt-2 leading-tight focus:outline-none focus:bg-white"
                name="brazeEvent"
                onChange={handleInput}
                type="text"
                value={state.brazeEvent}
              />
            </label>
          </div>
          {isEventTypeArray ? (
            <div className="w-1/2 sm:w-full px-3 md:mb-0">
              <label htmlFor="brazeEvent" className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-3">
                Event property
                <input
                  className="appearance-none block w-full bg-gray-200 text-gray-700 border border-red-500 rounded py-3 px-4 mt-2 leading-tight focus:outline-none focus:bg-white"
                  name="eventProperty"
                  onChange={handleInput}
                  type="text"
                  value={state.eventProperty}
                />
              </label>
            </div>
          ) : null}
        </div>
        <Toggle title="Do you want add a property?" value={isEventTypeArray} callback={handleEventType} />
      </div>
    </div>
  );
};

BrazeTrigger.propTypes = {
  components: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  handlerSetComponents: PropTypes.func.isRequired,
  id: PropTypes.string.isRequired,
};


export default BrazeTrigger;
